const benefits = [
  {
    icon: 'ri-map-pin-line',
    title: 'Local Market Knowledge',
    description:
      'Advice based on local market activity, buyer demand and comparable property sales in your area.',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'A Personal Selling Strategy',
    description:
      'A clear plan tailored to you, your property and your personal circumstances — never a one-size-fits-all approach.',
  },
  {
    icon: 'ri-home-smile-line',
    title: 'Professional Property Presentation',
    description:
      'Guidance on preparing and positioning your home to attract the right buyers and make a strong first impression.',
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Strong Marketing',
    description:
      'A coordinated property marketing approach designed to maximise visibility and generate serious buyer enquiries.',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Skilled Negotiation',
    description:
      'Support reviewing offers, negotiating terms and protecting your interests throughout the transaction.',
  },
  {
    icon: 'ri-chat-check-line',
    title: 'Guidance From Start to Finish',
    description:
      'Clear communication from the first conversation through closing — you will never be left wondering what happens next.',
  },
];

export default function WhySellWithCarol() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="text-primary-500 font-body text-sm tracking-widest uppercase mb-3">
            Why Work With Carol
          </p>
          <h2 className="font-heading text-foreground-900 text-2xl md:text-3xl lg:text-4xl mb-4">
            Sell With Confidence, Sell With Carol
          </h2>
          <p className="text-foreground-600 font-body text-base md:text-lg max-w-[650px] mx-auto">
            When you choose Carol Berry, you're choosing a professional who
            treats your sale with the care and attention it deserves.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7 hover:border-primary-200/60 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 mb-5 group-hover:bg-primary-100 transition-colors">
                <i className={`${benefit.icon} text-primary-500 text-xl`} />
              </div>
              <h3 className="font-heading text-foreground-900 text-lg mb-3">
                {benefit.title}
              </h3>
              <p className="text-foreground-600 font-body text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}